import React, { Component } from "react";
import PropTypes from "prop-types";
import Icon from "module-common/Icon";
import Picker from "module-common/Picker";
import { graphql, compose } from "react-apollo";
import {
  mutationAddLabelToStream,
  mutationDeleteLabelFromStream
} from "Apollo";
import {
  CaseManagementStore,
  CommonStore,
  ReplyStream,
  ShowNotice
} from "Store";

export default compose(
  graphql(mutationAddLabelToStream, { name: "noNeedMutate" }),
  graphql(mutationDeleteLabelFromStream, { name: "needMutate" })
)(
  class BubbleOption extends Component {
    static propTypes = {
      id: PropTypes.number,
      content: PropTypes.string,
      noNeed: PropTypes.bool,
      white: PropTypes.bool,
      channelName: PropTypes.string,
      channelType: PropTypes.string,
      url: PropTypes.string,
      showOptionMenu: PropTypes.bool
    };

    render() {
      const {
        noNeed,
        white,
        channelName,
        channelType,
        showOptionMenu
      } = this.props;

      if (showOptionMenu) {
        if (
          (channelName === "twitter" && channelType === "status") ||
          (channelName === "facebook" && channelType !== "message") ||
          (channelName === "instagram")
        ) {
          return (
            <Picker
              margin={0}
              options={[
                { label: "Reply" },
                noNeed ? { label: "Remove No Need" } : { label: "No Need" },
                { label: "Original Post" }
              ]}
              onSelected={this.onSelected}
            >
              <Icon
                name={white ? "arrow-down-white" : "arrow-down"}
                width={12}
                {...this.props}
              />
            </Picker>
          );
        } else {
          return (
            <Picker
              margin={0}
              options={[
                { label: "Reply" },
                noNeed ? { label: "Remove No Need" } : { label: "No Need" }
              ]}
              onSelected={this.onSelected}
            >
              <Icon
                name={white ? "arrow-down-white" : "arrow-down"}
                width={12}
                {...this.props}
              />
            </Picker>
          );
        }
      } else {
        if (
          (channelName === "twitter" && channelType === "status") ||
          (channelName === "facebook" && channelType !== "message") ||
          (channelName === "instagram")
        ) {
          return (
            <Picker
              margin={0}
              options={[{ label: "Original Post" }]}
              onSelected={this.onSelected}
            >
              <Icon
                name={white ? "arrow-down-white" : "arrow-down"}
                width={12}
                {...this.props}
              />
            </Picker>
          );
        } else {
          return null;
        }
      }
    }

    onSelected = selected => {
      const { id, content, url, channelTypeId } = this.props;
      if (selected.label === "Reply") {
        ReplyStream(
          id,
          CaseManagementStore.selectedCase.customerChannelHandler.name,
          content,
          channelTypeId
        );
      } else if (selected.label === "No Need") {
        try {
          this.props.noNeedMutate({
            variables: {
              stream: { id: id },
              labels: [{ id: CommonStore.noNeedId }]
            }
          });
          ShowNotice("label-add-success");
        } catch (error) {
          ShowNotice("label-add-error");
        }
      } else if (selected.label === "Remove No Need") {
        try {
          this.props.needMutate({
            variables: {
              stream: { id: id },
              labels: [{ id: CommonStore.noNeedId }]
            }
          });
          ShowNotice("label-delete-success");
        } catch (error) {
          ShowNotice("label-delete-error");
        }
      } else if (selected.label === "Original Post") {
        window.open(url);
      }
    };
  }
);



// WEBPACK FOOTER //
// ./src/module-case-management/content-panel/message-list/bubble/BubbleOptionWithStoreMutation.js